import { useContext } from "react";
import { viewportContext } from "../contexts/ViewportContext";

export const useViewport = () => {
  const {
    width,
    height,
    isAppOpened,
    isStale,
    isPoll,
    handleSetIsPoll,
    isFirstStale,
    handleUserReActivity,
    selectedOption,
    handleSetSelectedOption,
  } = useContext(viewportContext);
  return {
    width,
    height,
    isAppOpened,
    isStale,
    isPoll,
    handleSetIsPoll,
    isFirstStale,
    handleUserReActivity,
    selectedOption,
    handleSetSelectedOption,
  };
};
